import React from "react";
import "./About_Us.css";
import About_Service from "./about_service/About_Service";
import Our_Team from "./our_team/Our_Team";
import Vision_Mission from "./vision_mission/Vision_Mission";
import Book_Vehicle from "../common_components/book_vehicle/Book_Vehicle";
import Common_Banner from "../common_components/common_banner/Common_Banner";


const About_Us = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Home", link: "", isActive: true },
  ];

  return (
    <>
      <Common_Banner
        imgSrc={"/assets/images/common_banners/about_banner.png"}
        title_text="About Us"
        title_text2="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus."
        breadcrumbs={breadcrumbs}
      />

      <div className="About_Us_bg">
        <About_Service />
        <Vision_Mission />
        <Our_Team />
        <Book_Vehicle />
      </div>
    </>
  );
};

export default About_Us;
